
export class FirebaseConstants {

    public static jobOffers = "joboffers";
    public static deletedJobOffers = "deletedJobOffers";
    public static applicants = "applicants";
    public static applicantProfile = "applicantProfile";
    public static bewerber = "bewerber";
    public static contracts = "vorlagen";
    public static messages = "messages";
    public static variables = "variables";
    public static videos = "videos";
    public static teammembers = "teammembers";
    public static preferences = "preferences";
    public static customers = "customers";
    public static workflows = "workflows";
    public static codingapplicants = "codingapplicants";
    public static coderbyteapplicants = "coderbyteapplicants";
    public static companies = "companies";
    public static aiCVFeedback = "aiCVFeedback";
    public static howtos = "howTos";
    public static branding = "branding";
    public static blacklist = "blacklist";
    public static matchingSettings = "matchingSettings";
    public static dashboardSettings = "dashboardSettings";
    public static emailapplicants = "emailapplicants";
    public static kundennummer = "kundennummer";
    public static agents = "agents";
    public static ChatHistory = "MONARetrieval01";
    public static deletedApplicants = "deletedApplicants";
    public static archivedApplicants = "archivedApplicants";
    public static videosInProgress = "videosInProgress";
    public static monaLogs = "applicantErrors";
    public static errors = "errors";
    public static systemConfig = "system_config";
    public static profileTemplates = "profileTemplates";
    public static flowcharts = "flowcharts";
    public static monariAgents = "monari_agents";
    public static externalJobOffers = "externaljoboffers";
    public static accountConfig = "account_config";
}
